module.exports = __webpack_public_path__ + "img/register.dc5eccb5.svg";